import { useEffect } from 'react';
import { useEffectOnce } from './useEffectOnce';
import { addErrorHandler, setupLogger } from '../logging/setupLogger';
export const useSetupLogger = onError => {
  useEffectOnce(() => {
    setupLogger();
  });
  useEffect(() => {
    addErrorHandler(onError);
  }, [onError]);
};